// Curated icon + color picker options for channels. Only the icons users
// would realistically use for omnichannel comms — keeps the picker uncluttered.
import {
  MessageSquare, MessageCircle, Mail, Phone, PhoneCall, Video, Send, Inbox,
  Facebook, Instagram, Twitter, Linkedin, Globe, FileText, Smartphone,
  Headphones, Hash, Bot,
} from "lucide-react";

export const CHANNEL_ICONS = {
  MessageSquare, MessageCircle, Mail, Phone, PhoneCall, Video, Send, Inbox,
  Facebook, Instagram, Twitter, Linkedin, Globe, FileText, Smartphone,
  Headphones, Hash, Bot,
};

export const CHANNEL_ICON_OPTIONS = Object.keys(CHANNEL_ICONS);

// Tailwind class triplets for each colour key. Centralised so ChannelPill,
// ChannelDialog (preview), and dashboard charts can all reference the same set.
export const CHANNEL_COLORS = {
  slate:   { bg: "bg-slate-100",   text: "text-slate-700",   border: "border-slate-200",   dot: "bg-slate-500" },
  blue:    { bg: "bg-blue-100",    text: "text-blue-700",    border: "border-blue-200",    dot: "bg-blue-500" },
  indigo:  { bg: "bg-indigo-100",  text: "text-indigo-700",  border: "border-indigo-200",  dot: "bg-indigo-500" },
  emerald: { bg: "bg-emerald-100", text: "text-emerald-700", border: "border-emerald-200", dot: "bg-emerald-500" },
  amber:   { bg: "bg-amber-100",   text: "text-amber-700",   border: "border-amber-200",   dot: "bg-amber-500" },
  rose:    { bg: "bg-rose-100",    text: "text-rose-700",    border: "border-rose-200",    dot: "bg-rose-500" },
  purple:  { bg: "bg-purple-100",  text: "text-purple-700",  border: "border-purple-200",  dot: "bg-purple-500" },
  sky:     { bg: "bg-sky-100",     text: "text-sky-700",     border: "border-sky-200",     dot: "bg-sky-500" },
  fuchsia: { bg: "bg-fuchsia-100", text: "text-fuchsia-700", border: "border-fuchsia-200", dot: "bg-fuchsia-500" },
};

export const CHANNEL_COLOR_OPTIONS = Object.keys(CHANNEL_COLORS);

// Hex tokens for canvas/SVG-based renderers (Recharts) that can't consume
// Tailwind utility classes. Aligned with Tailwind's -500 shade for vibrancy.
export const CHANNEL_COLOR_HEX = {
  slate:   "#64748B",
  blue:    "#3B82F6",
  indigo:  "#6366F1",
  emerald: "#10B981",
  amber:   "#F59E0B",
  rose:    "#F43F5E",
  purple:  "#A855F7",
  sky:     "#0EA5E9",
  fuchsia: "#D946EF",
};

/** Look up the hex colour for a channel slice by name. Falls back to slate. */
export function channelHexByName(name, channelsList) {
  const ch = (channelsList || []).find(
    (c) => (c.name || "").toLowerCase() === (name || "").toLowerCase(),
  );
  return CHANNEL_COLOR_HEX[ch?.color] || CHANNEL_COLOR_HEX.slate;
}
